/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 13,
    height: 21,
    viewBox: '0 0 13 21',
    data: '<path pid="0" d="M3.069 6.568h7.24m-7.24 2.069h7.24M1 3.897h11.033v16.548H1V3.896zm0 0l9.535-2.452v2.451" _stroke="#848484" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/menu.js